import { GridColDef } from "@mui/x-data-grid-pro";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TableState {
  density: string;
  expand: boolean;
  editAll: boolean;
  currentColumns?: GridColDef[];
  currentData?: any[];
  columnFilters?: string[];
  pageSize: number;
  pageNumber: number;
  sellers: {
    checked: boolean;
    id: string;
    name: string;
  }[];
  sellerFilters: any[];
}

export const initialState: TableState = {
  density: "compact",
  expand: false,
  editAll: false,
  currentColumns: [],
  currentData: [],
  columnFilters: [],
  pageSize: 25,
  pageNumber: 1,
  sellers: [],
  sellerFilters: [],
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    changeDensity: (state: TableState, action: PayloadAction<string>) => {
      state.density = action.payload;
    },
    expandTable: (state: TableState, action: PayloadAction<boolean>) => {
      state.expand = action.payload;
    },
    editAll: (state: TableState, action: PayloadAction<boolean>) => {
      state.editAll = action.payload;
    },
    addCurrentColumns: (
      state: TableState,
      action: PayloadAction<GridColDef[]>
    ) => {
      state.currentColumns = action.payload;
    },
    addCurrentData: (state: TableState, action: PayloadAction<any[]>) => {
      state.currentData = action.payload;
    },
    addFilters: (state: TableState, action: PayloadAction<any>) => {
      state.columnFilters = action.payload;
    },

    updateFilters: (state: TableState, action: PayloadAction<any>) => {
      const obj = action.payload;
      //@ts-ignore
      state.columnFilters = [...obj, ...state.columnFilters];
    },
    clearFilters: (state: TableState) => {
      state.columnFilters = [];
    },
    changePageNumber: (state: TableState, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    changePageSize: (state: TableState, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    addSellers: (
      state: TableState,
      action: PayloadAction<{ id: string; name: string; checked: boolean }[]>
    ) => {
      state.sellers = action.payload;
    },
  },
});

export const {
  changeDensity,
  expandTable,
  addCurrentColumns,
  addCurrentData,
  addFilters,
  changePageNumber,
  changePageSize,
  clearFilters,
  addSellers,
  updateFilters,
} = tableSlice.actions;
